import React, { Component } from 'react';
import './App.css';
import { connect } from 'react-redux';
import { loadInfo } from './actions';
import Nav from './Nav';

class LoginDlg extends Component {


  state = { nev: localStorage.getItem('nev') || '', kod: ''};

  handleChange = (id) => (event) =>{
    this.setState({[id]: event.target.value});
  }
  onSubmit = (ev) => {
    console.log("submit",this.state);
    localStorage.setItem('nev',this.state.nev);
    localStorage.setItem('kod',this.state.kod);
    ev.preventDefault();
    console.log("dipsatching UserInfo",loadInfo);
    this.props.dispatch(loadInfo(this.state.nev,this.state.kod));
  }

  render() {
    return (
      <div className="sargaHatter">
        <Nav />
        <main role="main" className="container">
          <h1>Üdvözlünk az <img src="/uttars-logo.png" alt="úttárs" width='80%' /> programban</h1>
          <br />
          <form onSubmit={this.onSubmit}>
            <div className="form-group">
              <input type="text" className="form-control" id="nev" value={this.state.nev} onChange={this.handleChange('nev')} placeholder="Teljes név" />
            </div>
            <div className="form-group">
              <input type="text" className="form-control" id="kod"  value={this.state.kod} onChange={this.handleChange('kod')}  placeholder="Belépési kód" />
              <small className="form-text">Négyszámjegyű kód. Ha nem ismeri kérjen segítséget.</small>
            </div>
            <button type="submit" className="btn btn-danger">Belépés</button>
          </form>
        </main>
      </div >
    );
  }
}

export default connect()(LoginDlg);



// WEBPACK FOOTER //
// ./src/LoginDlg.js